export default __webpack_public_path__ + "static/media/no_image.d5586e74.svg";